import { useMutation } from '@tanstack/react-query';

import type { UpdateEmployeeEmploymentArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: UpdateEmployeeEmploymentArgs) => {
  return employeeService.updateEmployeeEmployment(data);
};

export const useEmployeeUpdateEmploymentMutation = () => {
  return useMutation<unknown, unknown, UpdateEmployeeEmploymentArgs>(mutationFn);
};
